import React from 'react'
import fourOfour from '@loyal_images/404.png'
import '@loyal_template/404.css'

import TitlePrint from 'App/Shell/TitlePrint'

const FourOFour = () => (
  <div className='container-404 container-fluid bg-white pt-5 pt-md-0'>
    <TitlePrint page='Página não encontrada' />
    <div className='container mt-5 mt-md-0 pt-5 pt-md-0'>
      <div className='row align-items-center h-100 py-5'>
        <div className='col-12 col-md-6'>
          <h2>Ops! Página não encontrada.</h2>
          <p>
            &bull; Verifique se você digitou corretamente o endereço desejado.
          </p>
          <p>
            &bull; O conteúdo pode ter sido removido ou não estar mais
            disponível.
          </p>
          <p>&bull; O servidor pode estar fora do ar no momento.</p>
        </div>
        <div className='ilustra_404 col-12 col-md-6 pos-relative'>
          <img
            className='mw-100 numero404 pendulum'
            src={fourOfour}
            alt='404 - Página não foi encontrada'
          />
        </div>
      </div>
    </div>
  </div>
)

export default FourOFour



// WEBPACK FOOTER //
// ./src/App/FourOFour/index.js